import React, { ReactNode, useState } from 'react';
import GenericDialogue from 'src/components/Dialogue/Dialogue';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';
import FontAwesomeIcon from '../Icon';
import './ServiceRequestFormDialog.scss';

interface ServiceRequestFormDialogProps {
  title: ReactNode;
  description?: string;
  footer?: ReactNode;
  onExit: () => void;
  onBack?: () => void;
  backLabel?: string;
  confirmOnExit?: boolean;
  children: ReactNode;
}

const ServiceRequestFormDialog = ({
  title,
  description,
  footer,
  onExit,
  onBack,
  backLabel = 'Back',
  confirmOnExit = true,
  children,
}: ServiceRequestFormDialogProps) => {
  const [isConfirmingExit, setIsConfirmingExit] = useState(false);

  const handleRequestClose = (): void => {
    if (!confirmOnExit) {
      onExit();
      return;
    }

    setIsConfirmingExit(true);
  };

  const backButton: ReactNode = onBack ? (
    <button type="button" className="sr-form-dialog-back" onClick={onBack}>
      <FontAwesomeIcon weight="light" glyph="arrow-left" />
      <span>{backLabel}</span>
    </button>
  ) : undefined;

  return (
    <>
      <GenericDialogue
        isOpen
        onClose={handleRequestClose}
        title={title}
        description={description}
        subheader={backButton}
        footer={footer}
        maxWidth="140rem"
        minHeight="95vh"
        maxHeight="95vh"
        animate={false}
      >
        {children}
      </GenericDialogue>

      {isConfirmingExit && (
        <ConfirmationModal
          variant="warning"
          title="Discard this service request?"
          message="If you leave now, the details you've entered won't be saved."
          confirmLabel="Discard"
          cancelLabel="Keep editing"
          onConfirm={onExit}
          onCancel={() => setIsConfirmingExit(false)}
        />
      )}
    </>
  );
};

export default ServiceRequestFormDialog;
